var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProductGroupInfo1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 93,
    viewBox: "0 0 102 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6504 41.6538V76.6538H70.8322V41.6538H32.6504Z",
    fill: "#D23778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.513 27.487L23.513 19.9486C23.513 19.0235 22.7631 18.2736 21.8376 18.2732L20.1623 18.2732C19.2372 18.2732 18.4873 19.0231 18.4869 19.9486L18.4869 27.487L10.9485 27.487C10.0235 27.487 9.27355 28.2369 9.27318 29.1623V30.8377C9.27318 31.7627 10.0231 32.5127 10.9485 32.513L18.4869 32.513L18.4869 40.0514C18.4869 40.9765 19.2368 41.7264 20.1623 41.7268L21.8376 41.7268C22.7627 41.7268 23.513 40.9765 23.513 40.0514L23.513 32.513L31.0514 32.513C31.9764 32.513 32.7267 31.7627 32.7267 30.8377V29.1623C32.7267 28.2373 31.9768 27.4873 31.0514 27.487L23.513 27.487Z",
    fill: "#D23778"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0142 48.0175H45.3778V60.7448L51.7414 54.3811L58.1051 60.7448V48.0175H64.4687V70.2902H39.0142V48.0175Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProductGroupInfo1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/product-group-info-1.a1d4d4f7483a42a1cd7f7e2b973c5f00.svg";